<div *ngIf="title" class="coverage-info-container">
  {{ title }}
</div>
